export const environment = {
  production: false,
  tenant_id: 'tenant1',
  server_url: 'http://139.144.100.23:9000',
  api_url: 'http://139.144.100.23:8080' ,
};
